export const ChevronLeftIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 320 512" {...props}>
    <path
      fill="currentColor"
      d="M34.5 239 229 44.7a24 24 0 0 1 34 0l22.6 22.7a24 24 0 0 1 0 33.9L131.5 256l154 154.8a24 24 0 0 1 0 33.8l-22.7 22.7a24 24 0 0 1-34 0L34.6 273a24 24 0 0 1 0-34z"
    />
  </svg>
);
